/* unplugin-vue-components disabled */import { ElLoadingDirective as __unplugin_directives_0 } from 'element-plus/es';import 'element-plus/es/components/loading/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElSwitch as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/switch/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dabc5a42"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "card-title flex justify-between",
  id: "card-title-icon"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应用图标", -1));
const _hoisted_3 = {
  class: "icon-container"
};
const _hoisted_4 = {
  class: "icon-tips"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "上传规则", -1));
const _hoisted_6 = {
  key: 0,
  class: "content"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*如不上传icon，当前渠道打包将使用母包的icon进行打包;", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*必须上传1024*1024的PNG，且不能包含透明度;", -1));
const _hoisted_9 = [_hoisted_7, _hoisted_8];
const _hoisted_10 = {
  key: 1,
  class: "content"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*如不上传icon，当前渠道打包将使用母包的icon进行打包;", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*如渠道有特定角标的要求，请上传带有渠道角标的图标，否则使用游戏包的默认图标;", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "*必须上传512*512的PNG图片", -1));
const _hoisted_14 = [_hoisted_11, _hoisted_12, _hoisted_13];
const _hoisted_15 = {
  class: "preview-img"
};
const _hoisted_16 = ["src"];
const _hoisted_17 = ["src"];
import { apiUsdkGetChannelIcon, apiUsdkGetChannelCorner, apiUsdkSaveChannelIcon } from '@/api/usdk';
import { UseComProps } from './hooks';
import SaveBtn from './saveBtn.vue';
import Splash from './splash.vue';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  props: {
    ...UseComProps()
  },
  setup(__props) {
    const props = __props;
    const isEdit = ref(false);
    const form = ref({
      icon_url: [],
      cornerStatus: props.channel.corner_status
    });
    const oldForm = ref();
    const previewImg = computed(() => {
      if (form.value.icon_url && form.value.icon_url.length) {
        return form.value.icon_url[0].url;
      } else {
        return '';
      }
    });
    const loading = ref(false);
    // 获取ICON
    const getIcon = () => {
      loading.value = true;
      apiUsdkGetChannelIcon({
        gid: props.gid,
        cid: props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          form.value.icon_id = res.data.id || '';
          form.value.icon_url = res.data.icon ? [{
            url: res.data.icon
          }] : [];
          oldForm.value = JSON.parse(JSON.stringify(form.value));
        }
        console.log('form', form.value);
      }).finally(() => {
        loading.value = false;
      });
    };
    const corner = ref('');
    // 获取渠道角标
    const getIconCorner = () => {
      apiUsdkGetChannelCorner({
        cid: props.channel.cid
      }).then(res => {
        if (res.code === 0) {
          corner.value = res.data.corner;
        }
      });
    };
    watch(() => props.commonInfo, val => {
      if (val) {
        if (props.channel.icon_status) {
          getIcon();
        } else {
          form.value.icon_url = props.commonInfo && [props.commonInfo.iconUrl] || [];
        }
      }
    }, {
      immediate: true
    });
    const handleClick = type => {
      if (type === 'edit') {
        isEdit.value = true;
      } else if (type === 'cancel') {
        isEdit.value = false;
      } else {
        handleSubmit();
      }
    };
    const handleSubmit = () => {
      var _form$value$icon_url$;
      const dict = {
        icon_url: {
          name: 'icon'
        }
      };
      loading.value = true;
      apiUsdkSaveChannelIcon({
        gid: props.gid,
        cid: props.channel.cid,
        iconId: form.value.icon_id,
        url: ((_form$value$icon_url$ = form.value.icon_url[0]) === null || _form$value$icon_url$ === void 0 ? void 0 : _form$value$icon_url$.url) || '',
        cornerStatus: form.value.cornerStatus
      }).then(res => {
        if (res.code === 0) {
          isEdit.value = false;
          customDataReport({
            eventName: 'set_app_icon',
            dict,
            before: oldForm.value,
            after: form.value,
            operatePath: '出包-渠道配置-基础配置-应用图标',
            gid: props.gid
          });
          oldForm.value = JSON.parse(JSON.stringify(form.value));
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    onMounted(() => {
      var _props$channel;
      getIconCorner();
      const dom = document.querySelector('#card-title-icon');
      if (!dom) {
        return;
      }
      const isShow = ((_props$channel = props.channel) === null || _props$channel === void 0 ? void 0 : _props$channel.plat) === 0;
      if (isShow) {
        dom.style.top = '178px';
      } else {
        dom.style.top = '117px';
      }
    });
    return (_ctx, _cache) => {
      const _component_u_upload = _resolveComponent("u-upload");
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_switch = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _directive_loading = __unplugin_directives_0;
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, !isEdit.value ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "btn-color cp",
        onClick: _cache[0] || (_cache[0] = $event => handleClick('edit'))
      }, "[编辑]")) : (_openBlock(), _createBlock(SaveBtn, {
        key: 1,
        loading: loading.value,
        onCancel: handleClick,
        onSave: handleClick
      }, null, 8, ["loading"]))]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_form, {
        model: form.value
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "上传ICON",
          prop: "icon_url",
          rules: {
            required: true,
            message: '请上传icon',
            trigger: 'change'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_u_upload, {
            accept: ".png",
            limit: 1,
            timestamp: "",
            imgWH: _ctx.channel.plat == 1 ? [1024, 1024] : [512, 512],
            modelValue: form.value.icon_url,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.icon_url = $event),
            disabled: !isEdit.value,
            listType: "picture-card"
          }, null, 8, ["imgWH", "modelValue", "disabled"]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _ctx.channel.plat == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9)) : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_14))])]),
          _: 1
        }), corner.value ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_form_item, {
          label: "角标开关"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_switch, {
            modelValue: form.value.cornerStatus,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.cornerStatus = $event),
            "active-value": 1,
            "inactive-value": 0,
            disabled: !isEdit.value
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        }), form.value.cornerStatus ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "ICON预览"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createElementVNode("img", {
            width: "100%",
            height: "100%",
            src: _unref(previewImg),
            alt: ""
          }, null, 8, _hoisted_16), _createElementVNode("img", {
            class: "corner",
            width: "100%",
            height: "100%",
            src: corner.value,
            alt: ""
          }, null, 8, _hoisted_17)])]),
          _: 1
        })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"])])), [[_directive_loading, loading.value]]), _createVNode(Splash, {
        gid: _ctx.gid,
        channel: _ctx.channel,
        commonInfo: _ctx.commonInfo
      }, null, 8, ["gid", "channel", "commonInfo"])]);
    };
  }
});